import {
  InnerContentItem,
  OuterContentItem,
  PrimaryTag,
  useFormatDisplayDate,
} from "@certn/cascadia-react";
import { formatDate } from "@certn/utils";
import { ArrayControlProps } from "@jsonforms/core";
import { Trans, useTranslation } from "react-i18next";

export function EmploymentHistorySummaryControl(props: ArrayControlProps) {
  const { t } = useTranslation();
  const { formatDisplayDate } = useFormatDisplayDate();

  return (
    <>
      {props.data
        ?.sort((a: any) => (a.end_date ? 1 : -1))
        .map((employer: any, index: number) => (
          <OuterContentItem
            key={index}
            title={employer.company_name}
            subtitle={formatDisplayDate({
              start_date: employer.start_date,
              end_date: employer.end_date,
            })}
            tag={
              !employer.end_date && (
                <PrimaryTag type="subtle">
                  <Trans>Current</Trans>
                </PrimaryTag>
              )
            }
            testID={`employer-summary-${index + 1}`}
          >
            <InnerContentItem
              label={t("Start date")}
              testID={`residences-summary-start-date-${index + 1}`}
            >
              {formatDate(employer.start_date, "MMMM yyyy")}
            </InnerContentItem>
            {employer.end_date && (
              <InnerContentItem
                label={t("End date")}
                testID={`residences-summary-end-date-${index + 1}`}
              >
                {formatDate(employer.end_date, "MMMM yyyy")}
              </InnerContentItem>
            )}
          </OuterContentItem>
        ))}
    </>
  );
}
